import api from "src/apis/api"

export async function fetchTeams({ q = "" } = {}) {
  const params = new URLSearchParams()
  if (q) params.set("q", q)
  const { data } = await api.get(`/api/v1/teams?${params}`)
  return data
}

export async function fetchTeam(id) {
  const { data } = await api.get(`/api/v1/teams/${id}`)
  return data.team
}

export async function createTeam(payload) {
  const { data } = await api.post("/api/v1/teams", { team: payload })
  return data
}

export async function updateTeam(id, payload) {
  const { data } = await api.patch(`/api/v1/teams/${id}`, { team: payload })
  return data
}

export async function deleteTeam(id) {
  const { data } = await api.delete(`/api/v1/teams/${id}`)
  return data
}
